<template>
  <div class="flex h-screen overflow-y-hidden">
    <SideBar />
    <ExtendedSideBar />
    <div class="flex-grow flex flex-col min-h-0 h-screen">
      <TopBar class="shrink-0" />
      <EmptyStateIndicator
        v-if="!$route.params.pageId"
        title="Kreiraj stranu"
        description="Kada kreiraš stranu, ostatak sadržaja će se pojaviti ovde."
        cta-text="Kreiraj stranu"
        @cta-click="onCreatePage"
      />
      <template v-else>
        <div class="flex-1 min-h-0 overflow-hidden flex flex-col">
          <router-view class="flex-1 min-h-0 overflow-hidden" />
          <GlobalPlayer />
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useBooksStore } from '@/store/books/index.js';
import { usePagesStore } from '@/store/pages/index.js';
import ExtendedSideBar from '@/components/app/library/ExtendedSideBar.vue';
import SideBar from '@/components/app/dashboard/SideBar.vue';
import TopBar from '@/components/app/dashboard/TopBar.vue';
import GlobalPlayer from '@/components/player/GlobalPlayer.vue';
import EmptyStateIndicator from '@/components/app/dashboard/EmptyStateIndicator.vue';
import CreatePage from '@/components/app/dashboard/modals/CreatePage.vue';
import { useModal } from 'vue-final-modal';

const route = useRoute();
const router = useRouter();
const booksStore = useBooksStore();
const pagesStore = usePagesStore();

async function redirectToFirstPageIfNeeded() {
  const bookId = route.params.bookId;
  if (!bookId || route.params.pageId) return;
  try {
    const pages = await pagesStore.fetchPages(bookId);
    if (pages?.length) {
      router.replace({ path: `/books/${bookId}/pages/${pages[0].id}` });
    }
  } catch (_) {}
}

onMounted(() => {
  booksStore.fetchBooks();
  redirectToFirstPageIfNeeded();
});

watch(() => route.params.bookId, redirectToFirstPageIfNeeded, { immediate: false });

function onCreatePage() {
  const { open, close } = useModal({
    component: CreatePage,
    attrs: {
      onConfirm() {
        close();
        redirectToFirstPageIfNeeded();
      },
      onCreated() {
        close();
        redirectToFirstPageIfNeeded();
      },
    },
  });
  open();
}
</script>
